import React from 'react';
import './Landing.css';
import Aos from "aos";
import "aos/dist/aos.css"
import { useEffect } from "react";

function Landing() {

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    <div id="landing">
      <div className="landing-container">
        <div data-aos="fade-up">
          <h1 className="landing-intro">Hi, my name is</h1>
        </div>
        <div data-aos="fade-up" data-aos-delay="100">
          <h2 className="landing-name">Mridul Goel.</h2>
        </div>
        <div data-aos="fade-up" data-aos-delay="200">
          <h3 className="landing-tagline">I build intelligent applications with AI.</h3>
        </div>
        <div data-aos="fade-up" data-aos-delay="300">
          <p className="landing-bio">
            I'm an AI Engineer specializing in designing and deploying scalable machine learning solutions. With a strong foundation in software development and a passion for cutting-edge technology, I transform complex problems into intelligent, impactful applications.
          </p>
        </div>
        <div data-aos="fade-up" data-aos-delay="400">
          <a href="#projects" className="landing-button">
            Check out my work!
          </a>
        </div>
      </div>
      
      {/* Social Links Sidebars */}
      <div className="social-sidebar left-sidebar">
        <a href="https://github.com/mridulgoel03" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
        <a href="https://www.linkedin.com/in/mridulgoel03/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
        <a href="https://twitter.com/mridulgoel03" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
      </div>
      
      <div className="email-sidebar right-sidebar">
          <a href="mailto:goelgpt@gmail.com">goelgpt@gmail.com</a>
      </div>
    </div>
  );
}

export default Landing;
